<template>
  <div class="content">
  <div style="width:100%;height:100%;background:#000;"
    v-loading="loading"
    element-loading-text="影像加载中"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
      {{imgSee}}
  </div>     

    <pops
      :title="提示"
      :show="popShow"
      width="30%"
      @close="closePop"
      center>
      <span class="infos">影像调阅失败，请返回重新调阅</span>

        <el-button type="primary" @click="closePop" class="sure">确 定</el-button>

    </pops>
  </div>
</template>

<script type="text/ecmascript-6">
  import http from '@/api/http'
  import pops from '@/components/common/pops/pop'
  import * as _ from '@/common/js/config'
  // import {cookies} from '@/api/util'
  import {message} from '@/common/js/messages'
  export default {
    name: 'imgView',
    components: {
      pops
    },
    data () {
      return {
        loading: true,
        show:false
      }
    },
    created() {
      this.postAycan()
    },
    methods: {
      popShow(payload) {
        this.show = payload
      },
      closePop() {
        this.show = false
        window.opener = null
        window.close()
      },
      postAycan() {
            let aycan = JSON.parse(sessionStorage.getItem('Aycan'))
            http.post('/edu/prepareAycan.json', aycan).then(res => {
              if (res.data.code == "0000") {
                this.loading = false
                this.imgSee == res.data.model
                sessionStorage.removeItem('Aycan')
              // }else if(){
              }else{
                this.loading = false
                this.show = true
                // message(res.data.msg,false);
              }
            }).catch(() => {
            })

      }
 //     _getRightW() {
 //       let width = document.getElementById('app').clientWidth
//        let right = document.getElementsByClassName('rightContent')
//        right[0].style.width = width - 180 + 'px'
//      }
    },
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .content
    width: 100vw
    height: 100vh
    display:flex
    justify-content:center
    align-items:center
    overflow: hidden
  .infos
    display block
    line-height: 50px
    width:100%
    text-align: center
  .sure
    width: 72px
    margin: 30px auto
    display flex
</style>



// WEBPACK FOOTER //
// imgView.vue?46da3c04